<template>
  <div id="app">
    <app-header></app-header>
    <router-view/>
    <app-footer></app-footer>
  </div>
</template>

<script>

  import header from '@/components/parts/header'
  import footer from '@/components/parts/footer'
  import CookieLaw from 'vue-cookie-law'

  import {mapActions, mapGetters} from 'vuex';

  export default {
    name: 'App',
    mounted(){
      this.initApp();

      setTimeout(e => {
        $(".cky-btn-accept").on("click",e => {
          this.$gtm.enable(true);
        });
      },1000);

    },
    methods : {
      ...mapActions(['initApp'])
    },
    components : {
      'app-header' : header,
      'app-footer' : footer,
      'cookie-law' : CookieLaw
    },
  }
</script>

<style  lang="scss">
@import '@/assets/css/colors.scss';
@import '@/assets/css/style.scss';
@import '@/assets/css/responsive.scss';
@import url('https://fonts.googleapis.com/css?family=Lato:400,500,700');
@import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css);
@import url(https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.5.2/animate.min.css);
</style>



// WEBPACK FOOTER //
// src/App.vue